import mitt from "mitt";
// Создаем типизированный event bus
var eventBus = mitt();
export var useMitt = function () {
    return eventBus;
};
// Экспортируем сам eventBus для прямого использования
export { eventBus };
